import type { Root } from '@/hooks/useAlgoliaSearch/types';
import type { CountryISO } from '@/constants/countries';

import { isCountryISO } from '@/constants/countries';

type Args = {
  query: string;
  company?: Pick<
    Root,
    'uniqueSymbol' | 'name' | 'exchangeCountryIso' | 'listings'
  >;
  countryISO?: CountryISO;
};

export const getBestMatchedSearchListing = ({
  query,
  countryISO,
  company,
}: Args) => {
  if (typeof company === 'undefined' || query === null) return null;

  const [_, tickerSymbol] = company.uniqueSymbol.split(':');

  const exchangeCountryIso = company.exchangeCountryIso.toLocaleLowerCase();

  let isPrimaryListingMatch = false;

  isPrimaryListingMatch =
    company.uniqueSymbol.toUpperCase() === query.toUpperCase();

  isPrimaryListingMatch =
    tickerSymbol.toUpperCase() === query.toUpperCase() &&
    isCountryISO(exchangeCountryIso) &&
    countryISO === exchangeCountryIso;

  if (isPrimaryListingMatch)
    return {
      name: company.name,
      exchangeCountryIso: company.exchangeCountryIso,
      uniqueSymbol: company.uniqueSymbol,
    };

  const secondaryListingMatch = company.listings.find((listing) => {
    if (listing.uniqueSymbol.toUpperCase() === query.toUpperCase()) {
      return true;
    }

    const [_, tickerSymbol] = listing.uniqueSymbol.split(':');

    const exchange = listing.exchangeCountryIso.toLocaleLowerCase();

    if (
      tickerSymbol.toUpperCase() === query.toUpperCase() &&
      isCountryISO(exchange) &&
      countryISO === exchange
    ) {
      return true;
    }

    return false;
  });

  const isSecondaryListingMatch = typeof secondaryListingMatch !== 'undefined';

  if (isSecondaryListingMatch)
    return {
      name: company.name,
      exchangeCountryIso: secondaryListingMatch.exchangeCountryIso,
      uniqueSymbol: secondaryListingMatch.uniqueSymbol,
    };

  // Return the primary listing as the default
  return {
    name: company.name,
    exchangeCountryIso: company.exchangeCountryIso,
    uniqueSymbol: company.uniqueSymbol,
  };
};
